/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NenPremiumToken,
  NenPremiumTokenInterface,
} from "../NenPremiumToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_firstBaseURI",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "attributeTopic",
            type: "string",
          },
          {
            internalType: "string",
            name: "attributeGene",
            type: "string",
          },
        ],
        indexed: false,
        internalType: "struct NenPremiumToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    name: "AttributeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
    ],
    name: "BaseUriUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "attributeTopic",
            type: "string",
          },
          {
            internalType: "string",
            name: "attributeGene",
            type: "string",
          },
        ],
        indexed: false,
        internalType: "struct NenPremiumToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "metadatas",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "attributeTopic",
            type: "string",
          },
          {
            internalType: "string",
            name: "attributeGene",
            type: "string",
          },
        ],
        internalType: "struct NenPremiumToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ownerAddress",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "attributeTopic",
            type: "string",
          },
          {
            internalType: "string",
            name: "attributeGene",
            type: "string",
          },
        ],
        internalType: "struct NenPremiumToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenIdCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "attributeTopic",
            type: "string",
          },
          {
            internalType: "string",
            name: "attributeGene",
            type: "string",
          },
        ],
        internalType: "struct NenPremiumToken.Attribute",
        name: "attribute",
        type: "tuple",
      },
    ],
    name: "updateAttribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_baseUri",
        type: "string",
      },
    ],
    name: "updateBaseUri",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenPremiumTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenPremiumTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenPremiumToken__factory extends ContractFactory {
  constructor(...args: NenPremiumTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenPremiumToken";
  }

  deploy(
    _firstBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenPremiumToken> {
    return super.deploy(
      _firstBaseURI,
      overrides || {}
    ) as Promise<NenPremiumToken>;
  }
  getDeployTransaction(
    _firstBaseURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_firstBaseURI, overrides || {});
  }
  attach(address: string): NenPremiumToken {
    return super.attach(address) as NenPremiumToken;
  }
  connect(signer: Signer): NenPremiumToken__factory {
    return super.connect(signer) as NenPremiumToken__factory;
  }
  static readonly contractName: "NenPremiumToken";
  public readonly contractName: "NenPremiumToken";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenPremiumTokenInterface {
    return new utils.Interface(_abi) as NenPremiumTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenPremiumToken {
    return new Contract(address, _abi, signerOrProvider) as NenPremiumToken;
  }
}
